<div class="simulator-container absolute left-[104px]">
  <div class="flex items-center justify-between">
    <div>
      <div class="text-[32px] font-bold mt-6">
        {{ 'update-content.title' | translate }}
      </div>
      <div class="mb-[30px]">{{ 'update-content.subtitle' | translate }}</div>
    </div>
    <div class="flex items-center">
      <rk-api-error-alert></rk-api-error-alert>
      <rk-button
        [text]="'update-content.save' | translate"
        (buttonClick)="saveConfig()"
        [isLoading]="isLoading$ | async"
      ></rk-button>
    </div>
  </div>
  <rk-app-configuration-shell></rk-app-configuration-shell>
</div>
